import styled from 'styled-components';

interface Props {
  className?: string;
  colors: [string, string, string, string, string];
  labels: [string, string, string];
}

const ChoroplethLegend = ({ className = '', colors, labels }: Props) => (
  <div className={className}>
    <div className="colors">
      {colors.map((color, index) => (
        <div style={{ backgroundColor: color }} className="color" key={`color-${index}`} />
      ))}
    </div>
    <div className="labels">
      {labels.map((label, index) => (
        <div key={`label-${index}`}>{label}</div>
      ))}
    </div>
  </div>
);

const StyledChoroplethLegend = styled(ChoroplethLegend)`
  width: min-content;

  .colors {
    display: flex;
    align-items: center;
    gap: 1px;
    > .color {
      width: 37px;
      height: 8px;

      &:first-child {
        border-radius: 3px 0 0 3px;
      }

      &:last-child {
        border-radius: 0 3px 3px 0;
      }
    }
  }

  .labels {
    margin-top: 3px;
    display: flex;
    justify-content: space-between;
    font-size: ${({ theme }) => theme.fontSizes.xs};
    line-height: ${({ theme }) => theme.lineHeights.xs};
    color: ${({ theme }) => theme.neutralTextWeak};
    font-weight: 400;
  }
`;

export default StyledChoroplethLegend;
